module.exports = __webpack_public_path__ + "static/media/246_X_78-02.4a256ace.svg";